import { render, staticRenderFns } from "./ShowCoverImage.vue?vue&type=template&id=5243c89a"
import script from "./ShowCoverImage.vue?vue&type=script&lang=js"
export * from "./ShowCoverImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports